import { useMemo } from 'react';
import { PaperProps } from '@mui/material';
import { useAdminInvoiceQuery } from '../../../../api/gql';
import { InvoiceInfoBox } from '../../../../modules/admin/invoice/InvoiceInfoBox';

type Props = {
  invoiceId: string;
} & PaperProps;

export const AdminInvoiceInfoBox = ({ invoiceId, ...rest }: Props) => {
  const { data, isLoading, isError } = useAdminInvoiceQuery({
    id: invoiceId,
  });

  const invoice = useMemo(() => data?.adminInvoice, [data?.adminInvoice]);

  return <InvoiceInfoBox invoice={invoice} isLoading={isLoading} isError={isError} {...rest} />;
};
